<template>
  <div class="index-banner">
    <div class="banner-list-box">
      <div class="banner-item"
        v-for="(v, k) in extendBanner"
        :key="k"
        :class="{pointer: v.jump_url}"
        @click.self="bannerHandle($event, v, k)"
        :style="{ background:`${v.backgroundColor?v.backgroundColor:'#fafbfe'} url(${v.img_url}) center/cover no-repeat`, opacity: activeBanner===k?1:0, zIndex: activeBanner===k?10:0}"
        v-observe-visibility="(isVisible, entry) => onVisibilityChanged(isVisible, entry, v, k)"
      ></div>
    </div>
    <div class="banner-control" v-if="extendBanner && extendBanner.length > 1" >
      <a v-for="(v,k) in extendBanner" :class="{active:activeBanner==k}" :key="k" @mouseover="bannerTo(k, $event)"></a>
    </div>
    <div class="banner-search-box" @click.stop="() => {}">
      <div class="tab-list">
        <div class="tab-item" :class="{active: tab === 0}" @click="changeTab(0)">签证</div>
      </div>
      <div class="tab-content" :class="{'tab-0': tab === 0}">
        <div class="visa-box" v-if="tab === 0">
          <div class="search-input-box">
            <div class="search-input-wrap">
              <input class="search-input" v-model="searchInput" @focus="searchInputFocus" @input="changeSearchInput" type="text" placeholder="搜索办签国家/地区" />
              <img class="search-icon" src="../../../assets/imgs/plane/icon-search.png" />
            </div>
            <div class="search-input-result" v-show="showSearchResult">
              <transition name="country-list">
                <div class="result-country-list" v-if="searchInput">
                  <div class="result-country-null-item" v-if="!searchCountryResult.length">暂无结果</div>
                  <template v-else>
                    <div class="result-country-item" v-for="(item, index) in searchCountryResult" :key="index" @click="gotoCountryPage($event, item)">
                      <div class="country-item-name">{{item.country}}</div>
                      <div class="country-item-type">{{item.visa_type_list.join(' ')}}</div>
                    </div>
                  </template>
                </div>
              </transition>
              <nav-country-list class="nav-country-list" v-show="!searchInput" :is-big="true" @on-hide-self="showSearchResult = false" @on-click-country="navCountryClick" :page-from="pageFrom"></nav-country-list>
            </div>
          </div>
          <div class="quick-country-box">
            <div class="quick-country-label">
              <img class="icon" src="../../../assets/imgs/plane/quick-country-label-blue.png" alt="">
            </div>
            <div class="quick-country-list">
              <div class="quick-country-item" @click="gotoCountryPage($event, item)" v-for="item in quickCountryList" :key="item.id">{{item.country}}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import 'pinyin4js';
import sensorsdata from 'sa-sdk-javascript';
import { mapState, mapMutations } from 'vuex';
import User from '../../../libs/user';
import utils from '../../../libs/utils';
import Http from '../../../libs/http';
import sensorService from '../../../services/sensor-service';

export default {
  name: 'index-banner',
  components: {
    // 这地方直接放上面引入就报错，所以就先这样吧。
    navCountryList: () => import('../../../components/common/nav-country-list'),
  },
  props: {
    banner: {
      type: Array,
      default() {
        return [];
      },
    },
    search: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      User,
      activeBanner: 0,
      defaultBanner: {
        img_url: 'https://o.666visa.cn/static/ssqpeer/homepage/homepage-1.png',
        jump_url: '',
        is_current_open: true,
        openRegister: true,
      },
      defaultPalmyouBanner: {
        img_url: 'https://o.666visa.cn/static/ssqpeer/homepage/palmyou-banner.png',
        jump_url: '',
      },
      showSearchResult: false,
      searchInput: '',
      searchCountryResult: [], // 搜索结果
      quickCountryList: [],
      tab: 0,
      pageFrom: '首页-顶部搜索',
    };
  },
  computed: {
    ...mapState('user', [
      'userInfo',
    ]),
    is_palmyou() {
      return this.userInfo.is_palmyou;
    },
    extendBanner() {
      // 未登录时需要添加一张默认的品牌banner
      if (!this.User.isLogin()) {
        return [this.defaultBanner, ...this.banner];
      } else if (this.is_palmyou) {
        return [this.defaultPalmyouBanner];
      }
      if (!this.banner.length) {
        return [{ img_url: 'https://o.666visa.cn/static/ssqpeer/homepage/homepage-1.png', jump_url: '' }];
      }
      return this.banner;
    },
    searchPinyinFormat() {
      return this.search.map(item => ({
        ...item,
        country_pinyin_shortcut: PinyinHelper.convertToPinyinString(item.country, '', PinyinFormat.FIRST_LETTER),
        country_alias_pinyin_shortcut: item.country_alias ? PinyinHelper.convertToPinyinString(item.country_alias, '', PinyinFormat.FIRST_LETTER) : '',
        country_alias_pinyin: item.country_alias ? PinyinHelper.convertToPinyinString(item.country_alias, '', PinyinFormat.WITHOUT_TONE) : '',
        country_alias: item.country_alias || '',
      }));
    },
  },
  created() {
    this.getQuickCountryList();
  },
  activated() {
    this.getQuickCountryList();
  },
  mounted() {
    this.initBannerInterval();
    document.body.addEventListener('click', this.searchInputBlur);
  },
  destroyed() {
    document.body.removeEventListener('click', this.searchInputBlur);
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    getQuickCountryList() {
      let url = '';
      if (!this.User.isLogin()) {
        url = '/sys/sys_config_get';
      } else {
        url = '/country_search_list_query';
      }
      Http.post(url, {}).then((res) => {
        this.quickCountryList = res.search_list;
      });
    },
    // 用于记录历史记录
    submitSearchCountry(countryInfo) {
      if (this.User.isLogin()) {
        return Http.post('/country_search', { country_id: countryInfo.id || countryInfo.visa_country_id, country: countryInfo.country }).then(() => {
          this.getQuickCountryList();
        });
      }
      return Promise.resolve().then(() => {
        this.getQuickCountryList();
      });

    },
    gotoCountryPage(e, countryInfo) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.submitSearchCountry(countryInfo).then(() => {
        // 商详神策埋点page_from字段
        const query = sensorService.getPageFrom(this.pageFrom);
        this.$router.push({ name: 'country', params: { id: countryInfo.id || countryInfo.visa_country_id }, query });
      });
    },
    navCountryClick(countryInfo) {
      this.submitSearchCountry(countryInfo);
    },
    initBannerInterval() {
      // 首页banner自动轮播
      if (this.extendBanner && this.extendBanner.length > 1) {
        // 后台有banner才可能轮播
        clearInterval(this.bannerInterval);
        this.bannerInterval = setInterval(() => {
          this.activeBanner = (this.activeBanner + 1) % this.extendBanner.length;
        }, 5000);
      }
    },
    bannerTo(idx, e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.activeBanner = idx;
      // 从新初始化
      this.initBannerInterval();
    },
    bannerHandle($event, banner, index) {
      sensorsdata.quick('trackHeatMap', $event.target);
      const mtaKey = `banner${banner.position}`;
      MtaH5.clickStat('banner', { [mtaKey]: 'true' });

      sensorsdata.track('BannerClick', {
        page_from: '首页',
        resource_position: index + 1,
        activity_url: banner.jump_url,
      });

      if (banner.position === 1) {
        utils.statsTrigger('ka6ik2sh');
      }

      if (banner.position === 2) {
        utils.statsTrigger('jfhrni3r');
      }

      if (banner.openRegister) {
        this.SHOW_LOGIN_BOX({ page: 5 });
        return;
      }

      if (banner.jump_url) {
        // 商详神策埋点page_from字段
        let url = sensorService.getURL(banner.jump_url, '首页-顶部banner');
        // 解决正式域名有两个，然后跳转问题
        if (url.indexOf('https://www.666visa.cn') > -1 && location.origin === 'https://666visa.cn') {
          url = url.replace('https://www.666visa.cn', 'https://666visa.cn')
        } else if (url.indexOf('https://666visa.cn') > -1 && location.origin === 'https://www.666visa.cn') {
          url = url.replace('https://666visa.cn', 'https://www.666visa.cn')
        }
        if (banner.is_current_open) {
          window.location.href = url;
        } else {
          this.openUrl(url);
        }
      }
    },
    openUrl(url, isBlank = true) {
      const a = document.createElement('a');
      a.setAttribute('href', url);
      if (isBlank) {
        a.setAttribute('target', '_blank');
      }
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    searchInputFocus(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.showSearchResult = true;
    },
    searchInputBlur() {
      this.searchInput = '';
      this.showSearchResult = false;
    },
    changeSearchInput() {
      let query = this.searchInput;
      if (query) {
        query = query.toLowerCase();
        this.searchCountryResult = this.searchPinyinFormat.filter(v => (v.cn_country.indexOf(query) > -1 ||
          v.en_country.toLowerCase().indexOf(query) > -1 ||
          v.country.indexOf(query) > -1 ||
          v.country_pinyin_shortcut.indexOf(query) > -1 ||
          v.country_alias_pinyin_shortcut.indexOf(query) > -1 ||
          v.country_alias_pinyin.indexOf(query) > -1 ||
          v.country_alias.indexOf(query) > -1),
        );
      } else {
        this.searchCountryResult = [];
      }
    },
    // 修改tab栏选中
    changeTab(tab) {
      this.tab = tab;
    },
    // 显示在屏幕中触发
    onVisibilityChanged(isVisible, entry, item, index) {
      if (isVisible && index === this.activeBanner) {
        sensorsdata.track('BannerExpose', {
          page_from: '首页',
          resource_position: index + 1,
          activity_url: item.jump_url,
        });
      }
      
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";
.index-banner{
  margin-top: -68px;
  height: 540px;
  position: relative;
  .banner-list-box{
    width: 100%;
    height: 100%;
    position: relative;
    .banner-item{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transition: all 1.5s;
    }
  }
  .banner-control{
    position: absolute;
    z-index: 20;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0;
    a{
      display: inline-block;
      width:12px;
      height: 4px;
      border-radius:1px;
      background: #fff;
      margin-right: 8px;
      transition: width 0.3s ease;
      overflow: hidden;
      position: relative;
      &.active{
        width: 40px;
        &::before{
          content: '';
          position: absolute;
          top: 0px;
          left: 0px;
          display: block;
          width: 0px;
          height: 4px;
          background-color: @new-blue;
          animation: loading 5s linear ;
        }
      }
    }
  }

  .banner-search-box{
    width: 924px;
    height: 162px;
    padding: 12px;
    position: absolute;
    bottom: 36px;
    left: 50%;
    transform: translateX(-50%);
    background:rgba(0,0,0,0.6);
    z-index: 25;
    .tab-list{
      height: 40px;
      display: flex;
      align-items: center;
      .tab-item{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 34px;
        position: relative;
        z-index: 1;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        .hot{
          width: 16px;
          height: 16px;
          margin-left: 4px;
        }
        &.active{
          color: #2F333D;
          &::after{
            content: "";
            width: 116px;
            height: 45px;
            border-radius: 4px 4px 0 0;
            background: #fff;
            transform: perspective(20px) rotateX(3deg);
            transform-origin: bottom left;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: -1;
          }
        }
        &:nth-child(2){
          justify-content: flex-start;
          // 机票
          &.active{
            &::after{
              width: 152px;
              transform-origin: bottom right;
              left: -5px;
            }
          }
        }
      }
    }
    .tab-content{
      width: 100%;
      height: 98px;
      background: #fff;
      border-radius: 4px;
      &.tab-0{
        border-radius: 0 4px 4px 4px;
      }
      .visa-box{
        padding: 12px 16px;
        .search-input-box{
          position: relative;
          .search-input-wrap{
            width: 100%;
            position: relative;
            .search-input{
              height: 40px;
              width: 100%;
              border-radius:2px;
              font-size: 18px;
              border: none;
              padding: 0 50px 0 16px;
              color: #2F333D;
              outline: none;
              border: 1px solid #DEE2E6;
              &::placeholder{
                color: #91999F;
              }
            }
            .search-icon{
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              width: 24px;
              height: 24px;
            }
          }
          .search-input-result{
            position: absolute;
            left: 0;
            top: 100%;
            margin-top: 8px;
            width: 100%;
            z-index: 25;
            .result-country-list{
              width: 100%;
              background: #fff;
              box-shadow:0px 8px 12px 0px rgba(57,61,70,0.06);
              border-radius:2px;
              font-size: 18px;
              max-height: 300px;
              overflow: auto;
              .result-country-null-item{
                width: 100%;
                height: 50px;
                color: #91999F;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .result-country-item{
                width: 100%;
                height: 50px;
                color: #91999F;
                display: flex;
                align-items: center;
                cursor: pointer;
                &:hover{
                  background: #F3F6F9;
                  .country-item-name{
                    color: @new-blue;
                  }
                }
                .country-item-name{
                  flex-shrink: 0;
                  padding: 0 16px;
                  color: #2F333D;
                  font-weight: 600;
                }
                .country-item-type{
                  flex-grow: 1;
                  margin-left: 24px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .quick-country-box{
          display: flex;
          align-items: flex-start;
          margin-top: 12px;
          .quick-country-label{
            width: 42px;
            height: 14px;
            flex-shrink: 0;
            margin-right: 8px;
            margin-top: 3px;
            .icon{
              width: 100%;
              height: 100%;
            }
          }
          .quick-country-list{
            flex-grow: 1;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;
            margin-right: -12px;
            margin-bottom: -10px;
            .quick-country-item{
              margin-right: 12px;
              margin-bottom: 10px;
              font-size: 14px;
              line-height: 22px;
              color: #2F333D;
              cursor: pointer;
              &:hover{
                color: @new-blue;
              }
            }
          }
        }
      }
      .plane-box{
        .filter-box{
          background: #fff;
          display: flex;
          padding: 16px;
          border-radius: 2px;
          line-height: 1;
          .filter-item{
            display: flex;
            flex-direction: column;
            .filter-label{
              color: #2F333D;
              font-size: 14px;
              margin-bottom: 8px;
              height: 14px;
            }
            .filter-content{
              display: flex;
              align-items: center;
              justify-content: center;
              height: 40px;
              color: #2F333D;
              .reverse-icon{
                width: 24px;
                height: 24px;
                cursor: pointer;
              }
              .s-date-picker{
                /deep/ .el-input__inner{
                  &::placeholder{
                    color: #2F333D;
                  }
                }
              }
            }
            &.depart-country{
              width: 240px;
            }
            &.reverse{
              margin: 0 8px;
            }
            &.arrive-country{
              width: 240px;
            }
            &.time{
              flex-grow: 1;
              margin-left: 16px;
            }
            &.submit{
              margin-left: 16px;
            }

          }
        }
      }
    }

  }
}
@keyframes loading{
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.country-list-enter-active {
  transition: all 0.15s ease;
  opacity: 0;
}
.country-list-enter-to{
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/index-banner.vue